import {Link} from 'react-router-dom'
import styled from 'styled-components'
import { z } from 'zod'
import { useForm } from "react-hook-form"
import styles from './LoginForm.module.scss'
import useStore from 'base/store'
import {Button} from 'common/components/V2'
import {useLogin, LoginValues} from '..'
import { useRBACLogin } from 'modules/rbac/api/auth'
import { setSession as setRBACSession } from 'modules/rbac/store/session'
import { Input } from './Login.Input'

const Wrapper = styled.div`
  width: 375px;
  & h1 {
    font-size: 64px;
    font-weight: 500;
    margin-bottom: 32px;
  }
  & > form {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    align-items: stretch;
    width: 100%;
  }
  & > form > div.input-wrapper {
    flex: 1;
    width: 100%;
    padding: 20px;
    border: 1px solid #FBFBFB;
    border-radius: 10px;
  }
  & form input {
    border: none;
    outline: none;
    background-color: transparent;
    background: transparent;
    color: #FBFBFB;
    font-size: 14px;
    font-weight: 400;
  }
  & p.forgot {
    text-align: right;
  }
`

export type FormFieldType<T> = {
  name: keyof T;
  type: string;
  label?: string;
  placeholder: string;
}
const Schema = z.object({
  email: z.string().email(),
  password: z.string().min(3).max(20),
});
type FormDataType = z.infer<typeof Schema>;

const formFields: FormFieldType<FormDataType>[] = [
  { name: "email",    type: "email",    placeholder: "Email", },
  { name: "password", type: "password", placeholder: "Password" },
]

export default function LoginForm() {
  const setSession = useStore((state) => state.setSession)
  const {mutate: login} = useLogin(setSession)
  const {mutate: rbacLogin } = useRBACLogin(setRBACSession)

  const {
    register, handleSubmit, // watch,
    // formState: { errors, isValid, isDirty }
  } = useForm<FormDataType>({
    mode: 'onChange',
    reValidateMode: 'onChange',
    defaultValues: undefined,
  })

  const handleFinish = (values: LoginValues) => {
    login(values)
    rbacLogin(values)
  }

  return (
    <Wrapper>
    <h1>
      <span style={{color: '#FBFBFB'}}>VC</span>
      &nbsp;
      <span style={{color: '#B4F1DB'}}>Online</span>
    </h1>
    <form onSubmit={handleSubmit(handleFinish)}>
      { formFields.map((f:FormFieldType<FormDataType>, index: number) => (
        <div key={index} className='input-wrapper'>
          <Input
            type={f.type}
            placeholder={f.placeholder}
            {...register(f.name)}
          />
        </div>
      )) }
      <p className="forgot">
        <Link className={styles.link} to="/password-reset">
          Forgot your password?
        </Link>
      </p>
      <div>
        <Button type="submit" $size='normal' $color='white' >
          Log in
        </Button>
      </div>
    </form>
    </Wrapper>
  )
}
